enum SupportedSubmissionTypes {
  ContentSubmission = 'content_submission',
  SocialSubmission = 'social_submission',
}

export { SupportedSubmissionTypes }
